import { API_URLS } from '@helpers/api';
import { getSvgIcon, Icon } from '@helpers/icons';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import LoadingIndicator from '@stories/Components/Misc/LoadingIndicator/LoadingIndicator';
import Pagination from '@stories/Components/Misc/Pagination/Pagination';
import SearchResultCard from '@stories/Components/SearchResultCard/SearchResultCard';
import qs from 'query-string';
import * as React from 'react';
import { ArrayParam, NumberParam, StringParam, useQueryParams, withDefault, } from 'use-query-params';
import HeroBannerInner from '../HeroBannerInner/HeroBannerInner';
import S from './SearchResults.styles';
const SearchResults = (props) => {
    const containerRef = React.useRef(null);
    const [params, setParams] = useQueryParams(Object.assign({
        pageIndex: withDefault(NumberParam, 1),
        pageSize: withDefault(NumberParam, 10),
        searchTerm: withDefault(StringParam, ''),
        sortBy: withDefault(StringParam, props.sortOptions?.[0]?.value ?? ''),
        type: withDefault(ArrayParam, []),
    }));
    const api = useApi({
        initialData: props.initialData,
        url: `${API_URLS.SEARCH}?${qs.stringify({
            ...params,
        })}`,
        validate: () => !!params.searchTerm,
    });
    const [searchedTerm] = React.useState(params.searchTerm);
    const [selected, setSelected] = React.useState([]);
    // Scroll to top when results are loaded
    React.useEffect(() => {
        if (api.status === 'complete') {
            containerRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
            if (api.data?.items.length) {
                logViewedEvents(api.data.items);
            }
        }
    }, [api.status]);
    React.useEffect(() => {
        setSelected(params.type);
    }, [params.type.length]);
    const [filterListActive, setFilterListActive] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeroBannerInner, { ...props.banner, searchBar: {
                label: props.banner.searchBar?.label ?? '',
                submitUrl: props.banner.searchBar?.submitUrl ?? '',
                searchTerm: searchedTerm ?? '',
                // onSubmit: (value: string) => {
                //   setSearchedTerm(value);
                //   containerRef.current?.scrollIntoView({ behavior: 'smooth' });
                //   setParams({ searchTerm: value, pageIndex: 1 }, 'pushIn');
                // },
            }, translations: props.translations }),
        React.createElement(S.Container, { ref: containerRef, flush: "bottom" },
            React.createElement(S.ResultsBlock, null,
                searchedTerm ? (React.createElement(React.Fragment, null,
                    React.createElement(S.ResultsHeading, null,
                        React.createElement(S.ResultsTitle, null,
                            props.translations?.['global.search.resultsTitle'],
                            React.createElement(S.ResultsCount, null, api.data?.totalItems ?? 0)),
                        (props.sortOptions || props.filters) && (React.createElement(S.FilteringWrapper, null,
                            props.sortOptions && (React.createElement(S.ResultsSort, null, props.sortOptions?.length && (React.createElement(React.Fragment, null,
                                React.createElement(S.SortLabel, { htmlFor: "sort" },
                                    getSvgIcon(Icon.SwitchVertical),
                                    React.createElement("span", null,
                                        props.translations?.['global.search.sortBy'],
                                        ': ',
                                        props.sortOptions.filter((option) => option.value === params.sortBy)[0]?.label)),
                                React.createElement(S.SortSelect, { id: "sort", value: params.sortBy, onChange: (e) => {
                                        setParams({ sortBy: e.target.value, pageIndex: 1 }, 'pushIn');
                                    } }, props.sortOptions.map((option) => (React.createElement("option", { key: option.value, value: option.value }, option.label)))))))),
                            props.filters && (React.createElement(S.FilterToggle, { onClick: () => setFilterListActive(!filterListActive) },
                                getSvgIcon(Icon.Filter),
                                props.translations?.['global.search.filtersToggle']))))),
                    api.data?.items.length ? (React.createElement(React.Fragment, null, api.data.items.map((item) => (React.createElement(SearchResultCard, { key: item.id, ...item, onClick: () => logClickEvent(item), highlightText: searchedTerm }))))) : (React.createElement(S.NoResultsText, null, props.translations?.['global.search.noResults'])),
                    React.createElement(Pagination, { totalCount: api.data?.totalItems ?? 0, value: params.pageIndex, pageSize: params.pageSize, onChange: (value) => {
                            setParams({ pageIndex: value }, 'pushIn');
                        }, ariaLabelNext: props.translations?.['global.search.nextPage'], ariaLabelPrevious: props.translations?.['global.search.previousPage'] }))) : (React.createElement(S.NoResultsText, null, props.translations?.['global.search.noTerm'])),
                api.status === 'loading' && (React.createElement(LoadingIndicator, { label: props.translations?.['global.search.loading'], layout: "fixed" }))),
            props.filters && (React.createElement(S.Filters, null,
                React.createElement(S.FiltersInner, { "data-active": filterListActive },
                    React.createElement(S.CloseFilters, { onClick: () => setFilterListActive(!filterListActive) }, getSvgIcon(Icon.CloseCircle)),
                    React.createElement(S.FiltersTitle, null, props.translations?.['global.search.filtersTitle']),
                    React.createElement(S.FiltersList, null, props.filters.map((filter, index) => (React.createElement(S.FilterButton, { key: `filter-${filter.label}-${index}`, buttonType: "default", "data-active": selected?.includes(filter.label), onClick: () => {
                            let values = params.type;
                            if (values.includes(filter.label)) {
                                values = values.filter((v) => v !== filter.label);
                            }
                            else {
                                values = [...values, filter.label];
                            }
                            setParams({ type: values, pageIndex: 1 }, 'pushIn');
                        } },
                        filter.label,
                        " (",
                        filter.resultCount,
                        ")"))))))))));
};
async function logClickEvent(result) {
    if (!result) {
        return;
    }
    try {
        await fetch(API_URLS.SEARCH_LOG_CLICK, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ item: result }),
        });
    }
    catch (error) {
        console.error('Error logging click:', error);
    }
}
async function logViewedEvents(results) {
    if (!results) {
        return;
    }
    try {
        await fetch(API_URLS.SEARCH_LOG_VIEWED, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: results }),
        });
    }
    catch (error) {
        console.error('Error logging click:', error);
    }
}
export default withQueryParams(SearchResults);
